// Import types and interface
import { useRouter } from "next/router";
import ContactFormType from "@/interfaces/Forms/FormType";

export default async function submitForm(formData: any) {
  const res = await fetch("/api/form-send", {
    method: "POST",
    body: formData,
  });

  return await res.json();
}
